import Cookies from 'js-cookie'
import {MRT_API_BASEPATH} from '../../ssr/constants'
import {hashSHA256} from '../../utils/utils'

const COOKIE_DURATION_BY_SITE = {
    'nutribullet-eu': 60,
}
const DEFAULT_COOKIE_DURATION = 365

const TDUID_COOKIE = 'tduid'
const TDCLID_SN_COOKIE = 'tdclid_sn'

export function storeTradedoublerCookies(siteId) {
    const params = new URLSearchParams(window.location.search)
    const tduid = params.get('tduid')
    const tdclid_sn = params.get('tdclid_sn')

    const expires = COOKIE_DURATION_BY_SITE[siteId] ?? DEFAULT_COOKIE_DURATION

    if (tduid) {
        Cookies.set(TDUID_COOKIE, tduid, {expires, sameSite: 'Lax'})
    }
    if (tdclid_sn) {
        Cookies.set(TDCLID_SN_COOKIE, tdclid_sn, {expires, sameSite: 'Lax'})
    }
}

function buildReportInfo(productItems) {
    if (!productItems?.length) return ''

    const parts = productItems.map((item) => {
        const f1 = encodeURIComponent(`f1=${item.productId}`)
        const f2 = encodeURIComponent(`f2=${item.productName ?? ''}`)
        const f3 = encodeURIComponent(`f3=${item.priceAfterOrderDiscount ?? item.price ?? 0}`)
        const f4 = encodeURIComponent(`f4=${item.quantity ?? 1}`)
        return `${f1}%26${f2}%26${f3}%26${f4}`
    })

    return parts.join('%7C')
}

export function useTradedoubler() {
    const sendTradedoublerConversion = async ({
        order,
        appOrigin,
        siteId,
        tradedoublerConfiguration,
    }) => {
        if (!tradedoublerConfiguration) return
        if (!order?.orderNo) return

        const tduid = Cookies.get(TDUID_COOKIE) || ''
        const tdclid_sn = Cookies.get(TDCLID_SN_COOKIE) || ''

        if (!tduid && !tdclid_sn) return

        const email = order?.customerInfo?.email
        const extid = email ? await hashSHA256(email) : undefined

        const orderValue = parseFloat(
            ((order?.orderTotal ?? order?.productTotal ?? 0) - (order?.taxTotal ?? 0)).toFixed(2),
        )

        const body = {
            locale: order?.customerLocaleId || 'en-US',
            orderNumber: order.orderNo,
            orderValue,
            currency: order.currency,
            voucher: order?.couponItems?.[0]?.code || undefined,
            tduid: tduid || undefined,
            tdclid_sn: tdclid_sn || undefined,
            extid,
            reportinfo: buildReportInfo(order?.productItems),
        }

        try {
            const response = await fetch(
                `${appOrigin}${MRT_API_BASEPATH}/post-tradedoubler-s2s?siteId=${siteId}`,
                {
                    method: 'POST',
                    headers: {'Content-Type': 'application/json'},
                    body: JSON.stringify(body),
                },
            )

            if (!response.ok) {
                console.error('[Tradedoubler] S2S call failed:', response.statusText)
            }
        } catch (error) {
            console.error('[Tradedoubler] Error sending S2S pixel:', error)
        }
    }

    return {sendTradedoublerConversion}
}
